import { foldMusteriNameKey } from './musteriAutoFromBank';

export const compactNameKey = (value) => foldMusteriNameKey(value).replace(/\s+/g, '');

export const normalizePhoneDigits = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('90') && digits.length >= 12) return digits.slice(-10);
  if (digits.startsWith('0') && digits.length >= 11) return digits.slice(-10);
  return digits.length >= 10 ? digits.slice(-10) : digits;
};

export const namesMatch = (left, right) => {
  const foldedLeft = foldMusteriNameKey(left);
  const foldedRight = foldMusteriNameKey(right);
  if (foldedLeft && foldedRight && foldedLeft === foldedRight) return true;
  const compactLeft = compactNameKey(left);
  const compactRight = compactNameKey(right);
  return Boolean(compactLeft && compactRight && compactLeft === compactRight);
};

export const resolveIslemMusteriName = (islem) => {
  const musteri = islem?.musteri;
  if (typeof musteri === 'string') return musteri.trim();
  if (musteri && typeof musteri === 'object') {
    const fromParts = `${musteri.isim || ''} ${musteri.soyisim || ''}`.trim();
    if (fromParts) return fromParts;
    return String(musteri.ad || musteri.name || musteri.musteriAdi || musteri.unvan || '').trim();
  }
  return String(islem?.musteriInput || islem?.musteriAdi || islem?.musteriAd || islem?.musteriIsim || '').trim();
};

export const islemBelongsToMusteri = (islem, musteri) => {
  if (!islem || !musteri) return false;
  const linked = islem.musteri;
  const islemId = linked && typeof linked === 'object' ? String(linked.id || '').trim() : '';
  const musteriId = String(musteri.id || '').trim();
  if (islemId && musteriId && islemId === musteriId) return true;

  const musteriName = `${musteri.isim || ''} ${musteri.soyisim || ''}`.trim();
  if (namesMatch(resolveIslemMusteriName(islem), musteriName)) return true;

  const islemPhone = normalizePhoneDigits(
    (linked && typeof linked === 'object' && (linked.iletisimNo || linked.telefon || linked.tel)) || islem.iletisimNo
  );
  const musteriPhone = normalizePhoneDigits(musteri.iletisimNo || musteri.telefon);
  if (islemPhone && musteriPhone && islemPhone === musteriPhone) return true;

  const islemTc = String(
    (linked && typeof linked === 'object' && linked.tcKimlikNo) || islem.tcKimlikNo || ''
  ).replace(/\D/g, '');
  const musteriTc = String(musteri.tcKimlikNo || '').replace(/\D/g, '');
  if (islemTc.length === 11 && musteriTc.length === 11 && islemTc === musteriTc) return true;

  return false;
};

export const findMusteriByTypedName = (musteriListesi, typedName) => {
  const name = String(typedName || '').trim();
  if (!name || !Array.isArray(musteriListesi)) return null;
  const matches = musteriListesi.filter((m) =>
    namesMatch(`${m?.isim || ''} ${m?.soyisim || ''}`.trim() || m?.ad || '', name)
  );
  return matches.length === 1 ? matches[0] : null;
};
